export default "__VITE_ASSET__368171e4__"